export default __webpack_public_path__ + "static/media/AGENT_MAINTENANCE_TEXT.75a6e4fc.png";